import { useAtom } from 'jotai';
import { useEffect, useRef } from 'react';

import { isInitialRenderWithResultsAtom } from '../atoms/searchPageAtoms';

/**
 * Hook to manage the isInitialRenderWithResultsAtom lifecycle
 * Used to control when SearchPageCardGrid shows skeleton vs actual cards
 */
export const useSearchCardLoading = (isLoadingSearchResults: boolean, totalFound: number) => {
    const [isInitialRenderWithResults, setIsInitialRenderWithResults] = useAtom(isInitialRenderWithResultsAtom);
    const previousLoadingState = useRef<boolean>(isLoadingSearchResults);

    // Reset atom to true when a new search starts (loading transitions from false to true)
    useEffect(() => {
        if (isLoadingSearchResults && !previousLoadingState.current) {
            setIsInitialRenderWithResults(true);
        }
        previousLoadingState.current = isLoadingSearchResults;
    }, [isLoadingSearchResults, setIsInitialRenderWithResults]);

    // Set atom to false when search completes
    useEffect(() => {
        if (!isLoadingSearchResults && isInitialRenderWithResults) {
            setIsInitialRenderWithResults(false);
        }
    }, [isInitialRenderWithResults, isLoadingSearchResults, setIsInitialRenderWithResults, totalFound]);

    return isInitialRenderWithResults;
};
